module.exports = __webpack_public_path__ + "52bc773fe63d9bcae751babbdadb1765.png";